import { Component, OnInit, Inject, HostListener, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { closeLoginDialog } from './login.actions';
import { invalidateShare } from '../share/share.actions';
import { invalidateProfile } from '../profile/profile.actions';
import { Config } from '../universal-config';

@Component({
  selector: 'nns-login-dialog',
  template: `
    <div class="nns-login-dialog-content" flex="noshrink" layout="column" layout-align="center center">
      <nimbus-auth [ngClass]="theme" [theme]="theme"
        *ngIf="authUrl"
        (login)="login()"
        [authUrl]="authUrl"
        [isShowForgetPasswordButton]="false"
      ></nimbus-auth>
    </div>
  `,
  styles: [`
    nimbus-auth {
      width: 100%;
    }

    :host /deep/ .nns-login-dialog-content {
      margin: auto;
    }
  `, `
    :host-context(.nns-theme-night) {
      background:#2f3737;
    }
  `]
})
export class LoginDialogComponent implements OnInit {
  @Input() public visual;
  public theme;
  public authUrl;

  constructor(
    public _store: Store<IAppState>,
    public _config: Config,
    @Inject('isBrowser') public isBrowser: boolean
  ) { }

  ngOnInit() {
    if (this.isBrowser) {
      window.addEventListener('message', this.handleCallback.bind(this), true);
      window.addEventListener('auth-close', this.close.bind(this), true);
    }

    this.authUrl = this._config.get('AUTH_API_PATH');
  }

  ngOnChanges() {
    this.theme = 'nns-theme-' + this.visual.theme;
  }

  ngOnDestroy() {
    if (this.isBrowser) {
      window.removeEventListener('message', this.handleCallback.bind(this), true);
      window.removeEventListener('auth-close', this.close.bind(this), true);
    }
  }

  @HostListener('document:keydown.esc', ['$event'])
  close() {
    this._store.dispatch(closeLoginDialog());
  }

  login() {
    this._store.dispatch(invalidateProfile());
    this._store.dispatch(invalidateShare());
    this.close();
  }

  handleCallback(message) {
    if (message.data && message.data.action) {
      const action = message.data.action;
      if (action === 'everhelper:authorized') {
        this.login();
      }
    }
  }
}
